<template>
  <div class="status__column-status">
    <div class="status__column-icon">
      <div class="icon-active">
        <slot name="icon"></slot>
      </div>
    </div>
    <div class="status__column-label">
      <router-link :to="link" exact>
        {{ label }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Status-Item',
  props: ['label', 'link'],
};
</script>

<style lang="scss" scoped>
@import "../main.scss";

.status__column {
  &-status {
    width: 17rem;
    height: 3.5rem;
    margin: 0 auto;

    display: flex;
  }

  &-icon {
    width: 3.5rem;
    height: 100%;
    display: flex;
    align-items: center;

    .icon-active {
      height: 2.2rem;
      width: 1.8rem;
      display: block;
      background: url("/src/assets/img/Check.svg");
      background-size: 1.8rem 2.2rem;
    }
  }

  &-label {
    color: #a9a9a9;
    display: block;
    font-family: Heebo;
    font-size: 1.6rem;
    line-height: 24px;

    flex: 1;
    display: flex;
    align-items: center;

    p {
      margin: 0;
    }

    & > a {
      text-decoration: none;
      color: #a9a9a9;
    }

    .label-active {
      color: #212121;
      font-weight: bold;
    }
  }
}
</style>

